require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6682bo/master/~/core-js/fn/object/assign.js
// module id = 78
// module chunks = 1